import { render, staticRenderFns } from "./Feature10Demo.vue?vue&type=template&id=4a1bd175&"
import script from "./Feature10Demo.vue?vue&type=script&lang=js&"
export * from "./Feature10Demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports